module.exports = __webpack_public_path__ + "img/no_device.5a5882ba.png";